<template>
  <li :class="classes">
    <span
      v-if="item.label"
      class="former-separator-label"
    >
      {{ item.label }}
    </span>

    <span class="former-separator-bar" />

    <button
      v-if="item.removable"
      class="former-separator-remove"
    >
      <font-awesome-icon icon="times" />
    </button>
  </li>
</template>

<script>
  export default {
    name: 'FormerSeparator',
    props: {
      item: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      classes() {
        const classes = ['former-separator'];

        if (this.item.label) {
          classes.push('former-separator-labeled');
        }

        return classes;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-separator {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: $gutter 0;

    @media all and (min-width: $breakpoint-desktop) {
      margin: $gutter-big 0;
    }

    & + &,
    &:first-child,
    &:last-child {
      display: none;
    }
  }

  .former-separator-labeled {
    margin-top: $gutter-bigger;
    margin-bottom: $gutter-small;

    &:last-child {
      display: flex;
      margin-bottom: 0;
    }
  }

  .former-separator-label {
    border-radius: $button-smallest * 0.5;
    line-height: $button-smallest;
    padding-right: $gutter-small;
  }

  .former-separator-remove {
    @include button-reset;

    border: 1px solid $gray-dark;
    border-radius: $button-smallest * 0.5;
    color: $red;
    height: $button-smallest;
    margin-right: -$gutter-smaller;
    text-align: center;
    width: $button-smallest;
  }

  .former-separator-bar {
    border-top: 1px solid $gray-dark;
    border-radius: 1px;
    display: block;
    flex: 1;
    height: 1px;
  }
</style>
